var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.768,
    height: 98.768,
    viewBox: "0 0 98.768 98.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_16_",
    "data-name": "download (16)",
    transform: "translate(-164.461 -162.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M261.215,224.98a34.655,34.655,0,1,0,34.655,34.655,34.677,34.677,0,0,0-34.655-34.655Zm-3.837,52.23-15.347-15.594,4.95-4.95,10.4,10.52L280.4,244.537l4.95,4.95Zm7.179.618-1.61-1.732L285.6,253.448l1.609,1.609Z",
    transform: "translate(-47.493 -47.487)",
    fill: "#019d01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M263.229,212.52c0-3.094-5.445-5.694-5.941-8.664-.619-3.094,3.466-7.426,2.351-10.273s-7.179-3.218-8.911-5.694c-1.733-2.6.371-8.169-1.733-10.4s-7.8-.124-10.4-1.857c-2.475-1.733-2.723-7.8-5.57-8.911-2.846-1.238-7.3,2.847-10.273,2.228s-5.445-6.065-8.664-6.065c-3.094,0-5.694,5.446-8.664,5.941-3.094.619-7.425-3.466-10.273-2.351s-3.218,7.179-5.694,8.911c-2.6,1.733-8.169-.371-10.4,1.733s-.124,7.8-1.857,10.4c-1.733,2.475-7.8,2.723-8.911,5.57-1.238,2.846,2.846,7.3,2.228,10.273s-6.065,5.446-6.065,8.664c0,3.094,5.446,5.694,5.941,8.664.619,3.094-3.466,7.426-2.351,10.273s7.179,3.218,8.911,5.694c1.733,2.6-.371,8.169,1.733,10.4s7.8.124,10.4,1.857c2.475,1.733,2.723,7.8,5.57,8.911,2.846,1.238,7.3-2.846,10.273-2.228s5.446,6.065,8.664,6.065c3.094,0,5.694-5.446,8.664-5.941,3.094-.619,7.425,3.466,10.273,2.351s3.218-7.179,5.694-8.911c2.6-1.733,8.169.371,10.4-1.733s.124-7.8,1.857-10.4c1.733-2.475,7.8-2.723,8.911-5.57,1.238-2.846-2.846-7.3-2.228-10.273.5-3.1,6.065-5.571,6.065-8.664Zm-49.506,36.634a37.008,37.008,0,1,1,37.008-37.008,37.029,37.029,0,0,1-37.008,37.008Z",
    transform: "translate(0 0)",
    fill: "#019d01"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImg);
export default __webpack_public_path__ + "static/media/download_img.00c77e1f9029f001ba9c809a72ed69d3.svg";
export { ForwardRef as ReactComponent };